export const stripHTMLTags = (input: string | null | undefined) => {
  if (!input) {
    return ''
  }
  return input.replace(/(<([^>]+)>)/gi, '')
}

export const isHTML = (input: string): boolean => {
  return /<\/?[a-z][\s\S]*>/i.test(input)
}
